export const brandPagesUrls = {
  default: 'brands',
  en: 'brands',
  nl: 'merken',
  fr: 'marques',
  de: 'marken',
  it: 'marche',
  es: 'marcas',
}
